const CONTAINER_SELECTOR = ".js-scrollable-nav-arrows-list";
const PREV_ARROW_SELECTOR = ".js-scrollable-nav-arrows-prev";
const NEXT_ARROW_SELECTOR = ".js-scrollable-nav-arrows-next";
const SCROLL_DISTANCE = 200;
const SCROLL_PERCENTAGE = 0.6;
const IS_VISIBLE_CLASS = "is-visible";
/**
 * Initialize scrollable navigation arrows for a single container
 * @param container The container element
 */
function initScrollableNavArrows(container) {
    var _a;
    const arrowsContainer = (_a = container.parentElement) !== null && _a !== void 0 ? _a : container;
    const prevArrow = arrowsContainer.querySelector(PREV_ARROW_SELECTOR);
    const nextArrow = arrowsContainer.querySelector(NEXT_ARROW_SELECTOR);
    if (!prevArrow || !nextArrow) {
        console.warn("[ScrollableNavArrows] Cannot find navigation arrows");
        return;
    }
    const observerOptions = {
        root: container,
        threshold: 0.8,
    };
    const isContainerScrollable = () => container.scrollWidth > container.clientWidth;
    // Observe first element to toggle prev arrow visibility
    const prevObserver = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting && isContainerScrollable()) {
            prevArrow.classList.add(IS_VISIBLE_CLASS);
        }
        else {
            prevArrow.classList.remove(IS_VISIBLE_CLASS);
        }
    }, observerOptions);
    const firstElement = container.firstElementChild;
    if (firstElement) {
        prevObserver.observe(firstElement);
    }
    // Observe last element to toggle next arrow visibility
    const nextObserver = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting && isContainerScrollable()) {
            nextArrow.classList.add(IS_VISIBLE_CLASS);
        }
        else {
            nextArrow.classList.remove(IS_VISIBLE_CLASS);
        }
    }, observerOptions);
    const lastElement = container.lastElementChild;
    if (lastElement && lastElement !== firstElement) {
        nextObserver.observe(lastElement);
    }
    // FIXME: think about more robust scroll mechanism with scroll-snap
    // Explanation: scrollBy doesn't work properly with `scroll-snap-align: start; scroll-snap-stop: always;` styles on some browsers, so using scrollTo by percentage of container width as an alternative
    const usePercentageScroll = Skubacz.Device.browser.isFirefox() || Skubacz.Device.browser.isEdge();
    prevArrow.addEventListener("click", () => {
        if (usePercentageScroll) {
            container.scrollTo({
                left: container.scrollLeft - container.clientWidth * SCROLL_PERCENTAGE,
                behavior: "smooth",
            });
        }
        else {
            container.scrollBy({
                left: -SCROLL_DISTANCE,
                behavior: "smooth",
            });
        }
    });
    nextArrow.addEventListener("click", () => {
        if (usePercentageScroll) {
            container.scrollTo({
                left: container.scrollLeft + container.clientWidth * SCROLL_PERCENTAGE,
                behavior: "smooth",
            });
        }
        else {
            container.scrollBy({
                left: SCROLL_DISTANCE,
                behavior: "smooth",
            });
        }
    });
}
export default {
    init: () => {
        if (Skubacz.Device.screen.isMobileSize()) {
            return;
        }
        document.querySelectorAll(CONTAINER_SELECTOR).forEach((c) => {
            initScrollableNavArrows(c);
        });
    },
};
